/**
 * 블소 - 문파
 */
import { Fragment } from 'react';
import { INshop, IGoods, ISetGoods, l10nType } from "@type/index";
import { CUR_NETWORK, NSHOP_DOMAIN, OLD_NSHOP_DOMAIN, SERVICE_ALIAS } from '@constants/index';
import { numberWithCommas } from '@utils/index';

// 1차 오픈 - 기존 N샵
export const setNshopItem = (item: INshop, l10n: l10nType, serviceAlias: string): ISetGoods | null => {
    return item && typeof item === 'object' ? {
        id: item?.id,
        goodsName: item?.goodsName,
        basicSalePrice: 0,
        rewardValue: item?.rewardPoint,
        shopCode: '',
        thumbnailUri: item?.thumbnail,
        description: item?.contents,
        salePrice: item?.price,
        tags: [],
        currencyGroupId: item?.currencyGroupId,
        url: new URL(item?.url, OLD_NSHOP_DOMAIN[serviceAlias][CUR_NETWORK])?.toString(),
        serverName: serviceAlias === SERVICE_ALIAS.AION ? (item?.shopId === 21 ? l10n?.filter?.aionClassicServer : l10n?.filter?.aionLiveServer) : '',
        currencyType: item?.currencyGroupId === 13 ? 'point' : 'cash'
    } : null;
};

// 2차 오픈 - 통합 N샵
export const setGoodsItem = (item: IGoods, l10n: l10nType, serviceAlias: string): ISetGoods | null => {
    return item && typeof item === 'object' ? {
        ...item,
        url: `${NSHOP_DOMAIN[CUR_NETWORK]}/${item?.shopCode}/goods/${item?.id}`,
        serverName: serviceAlias === SERVICE_ALIAS.AION ? (item?.shopCode === 'aionc' ? l10n?.filter?.aionClassicServer : l10n?.filter?.aionLiveServer) : '',
        currencyType: item?.currencyGroupId === 13 ? 'point' : 'cash'
    } : null;
};


export const NshopArticle = ({ item, l10n, option, isGoodsLive }: {item: INshop | IGoods; l10n: l10nType; option: IOption; isGoodsLive: boolean;}) => {
    const { serviceAlias } = option;
    const data = !isGoodsLive ? setNshopItem(item as INshop, l10n, serviceAlias) : setGoodsItem(item as IGoods, l10n, serviceAlias);

    if(!data) {
        return <Fragment />;
    }

    const { url, thumbnailUri, serverName, goodsName, currencyType, salePrice, rewardValue } = data;
    return <div className="search-item-content">
        <div className="search-item-thumbnail">
            <a href={ url }>
                <div className="search-item-thumbnail-inner">
                    { thumbnailUri ? <img src={ thumbnailUri } alt="아이템" /> : <Fragment /> }
                    { serverName ? <span className="server-name">{serverName}</span> : <Fragment /> }
                </div>
            </a>
        </div>
        <div className="search-item-article">
            <div className="search-item-title">
                <a href={ url } dangerouslySetInnerHTML={{ __html: goodsName }}></a></div>
            <div className="search-item-info">
                <span className={`${currencyType}`}>{ numberWithCommas(salePrice) }</span>
                <span className="point">{ rewardValue }({ l10n?.template?.accumulate })</span>
            </div>
        </div>
    </div>;
};